import axios from '../utility/customAxios';
import { signIn, signOut, fetchAuthSession, type SignInInput, fetchUserAttributes } from 'aws-amplify/auth';
import { Authentication } from '../models/Authentication';
import { LeoAPIProfileUrl } from '../resources/api-constants';

export class AwsService {
    public async authenticate({ username, password }: SignInInput): Promise<Authentication> {
        const { isSignedIn } = await signIn({ username, password });
        if (isSignedIn) {
            const session = await fetchAuthSession();
            const user = await fetchUserAttributes();
            const bearer = session.tokens?.accessToken.toString();
            await axios.get(LeoAPIProfileUrl, {
                headers: {
                    Accept: "*/*",
                    Authorization: "Bearer " + bearer,
                }
            }).catch(async (error: any) => {
                await signOut();
                throw error;
            });

            if (bearer) {
                return {
                    token: bearer,
                    expire: (session.tokens?.accessToken.payload.exp ? session.tokens?.accessToken.payload.exp * 1000 : Date.now() + 3600000),
                    nickname: (user.name ? user.name : "")
                }
            }
            throw "Bearer is null"
        }
        throw "Authentication failed"
    }

    public async refeshAuth(): Promise<Authentication> {
        const session = await fetchAuthSession();
        if (session) {
            const user = await fetchUserAttributes();
            const bearer = session.tokens?.accessToken.toString();
            await axios.get(LeoAPIProfileUrl, {
                headers: {
                    Accept: "*/*",
                    Authorization: "Bearer " + bearer,
                }
            });

            if (bearer) {
                return {
                    token: bearer,
                    expire: (session.tokens?.accessToken.payload.exp ? session.tokens?.accessToken.payload.exp * 1000 : Date.now() + 3600000),
                    nickname: (user.name ? user.name : "")
                }
            }
            throw "Bearer is null"
        }
        throw "Authentication failed"
    }
    public async unauthenticate() {
        await signOut();
    }
}